export const VIDEO_SELECTOR = 'video';

export const SOCIAL_VIDEO_CONTAINER = 'js-social-video-container';
export const SOCIAL_VIDEO_POSTER = 'js-social-video-poster';
export const SOCIAL_VIDEO = 'js-social-video';
export const SOCIAL_VIDEO_SMALL_ICON = 'js-video-sound-small-icon';
export const SOCIAL_VIDEO_BIG_ICON = 'js-video-sound-big-icon';
export const SOCIAL_VIDEO_SOUND_OFF_ICON = 'js-social-video-sound-off-icon';
export const SOCIAL_VIDEO_SOUND_ON_ICON = 'js-social-video-sound-on-icon';
